import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_News/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_News/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_News/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_News/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_News/Delete',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
};
